module.exports = __webpack_public_path__ + "img/logo.ca368f59.png";